import request from '@/utils/request';

// 1. admin获取用户列表
export function fetchAdminUserList(params) {
  return request({
    url: '/ajax/system/users',
    method: 'get',
    params: params || {
      page: 1,
      size: 99
    }
  });
}

// 2. admin获取用户信息
export function fetchAdminUserInfo(uid) {
  return request({
    url: '/ajax/system/user/' + uid,
    method: 'get'
  });
}

// 3. admin更新用户信息
export function updateAdminUserInfo(data) {
  return request({
    url: '/ajax/system/user',
    method: 'PUT',
    data: data
  });
}

// 4. admin删除用户
export function deleteAdminUser(userID) {
  return request({
    url: '/ajax/system/user/' + userID,
    method: 'DELETE'
  });
}

// 5. admin新增用户
export function addAdminUser(data) {
  return request({
    url: '/ajax/system/user',
    method: 'post',
    data: data
  });
}

// 1. 获取用户列表
export function fetchUserList(params) {
  return request({
    url: '/ajax/enterprises/' + params.ID + '/users',
    method: 'get',
    params: params || {
      page: 1,
      size: 99
    }
  });
}



// 4. 删除用户
export function deleteUser(params) {
  return request({
    url: '/ajax/enterprises/' + params.ID + '/user',
    method: 'DELETE',
    params: { uid: params.uid }
  });
}

// 5. 新增用户
export function addUser(data) {
  return request({
    url: '/ajax/enterprises/' + data.ID + '/user',
    method: 'post',
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js